<template>
  <div style="background: url('/img/assets/BACKGROUND.jpg')">
    <div v-if="isScreenChoice === 'generic' || isScreenChoice === 'undefined'">
      <div v-if="isCurrentStep === 'continue'" class="stepper-wrapper">
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        isScreenChoice === 'card' ||
        isScreenChoice === 'loan' ||
        isScreenChoice === 'undefined'
      "
    >
      <div v-if="isCurrentStep === 'continue'" class="stepper-wrapper">
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
        <div class="stepper-item completed">
          <div class="step-counter">
            <i class="material-icons" style="font-size: 20px; color: white"
              >done</i
            >
          </div>
        </div>
      </div>
    </div>
    <MainForm
      :name="FORM_NAMES.onboardingDigitalProgress"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPageDigital"
      ui-title=""
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.continue"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
        <FieldsetModel :ui="uiBaseFieldset" name="fieldSetContinue" ui-title="">
          <p
            style="
              padding-bottom: 30px;
              text-align: center;
              color: #6e3dea;
              font-weight: 500;
              font-size: 30px;
            "
          >
            Please be with us while we review your application. This will only
            take a few moments...
          </p>
          <div id="container">
            <p>
              <img
                class="center"
                src="/img/assets/card/World - Cash Up.png"
                width="250px"
                height="150px"
              />
            </p>

            <div  id="progress-bar" class="loader"></div>
          </div>
          <p  hidden class="saving" id="spinner">
            <span class="dot"></span>
            <span class="dotText">Give us few seconds...</span>
          </p>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetEmiratesIdNumber from "@/forms/components/shared/fieldsets/emirates-id-number";
import StepOtp from "@/forms/components/cards/credit-card-digital/steps/otp";

import StepOCREmirates from "@/forms/components/cards/credit-card-digital/steps/ocr-emirates";
import IdentityReview from "@/forms/components/cards/credit-card-digital/steps/identity-review";
import FieldsetIBAN from "@/forms/components/cards/stp-card/steps/fieldsets/iban-number";
import flowManager from "@/lib/services/flow-manager";
import FieldIncome from "@/forms/components/shared/fields/income";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  NBCSuggestions,
  Card,
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";

import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";

import FieldsetEmail from "@/forms/components/shared/fieldsets/email";

import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";

import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import formService from "@/forms/api/services/form";
import creditScoreCalService from "@/forms/api/services/credit-score-cal-digital";
import sendGAEvent from "@/forms/helpers/ga-events";
import routeManager from "@/router";
import {
  SPENDING,
  YESNO,
  INCOME,
  CARD_USE,
  CARD_USE_LONG,
  REWARDSTYPE,
  FEATURES_NBC_CARDS,
  //FIELD_NAMES
} from "@/forms/constants/nbc-logic";
import {
  SET_BANK_NAME,
  SET_FIRST_NAME,
  SET_SECOND_NAME,
  SET_BASIC_ELIGIBILITY,
  SET_PRODUCT_TYPE,
  SET_CARD_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
  SET_VARIABLE_INCOME,
  SET_UAE_VINTAGE,
} from "@/lib/constants/mutations";
import {
  DIGIT_CHARS,
  ADDRESS_CHARS,
  DECISION_FORM_MAP,
} from "@/forms/constants/onboarding-logic";
import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";

export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    CheckWrapper,
    Button,
    Expandable,
    FieldsetEmiratesIdNumber,
    StepOtp,
    IdentityReview,
    StepOCREmirates,
    FieldsetIBAN,
    ProductCover,
    SidePanel,
    Grid,
    NBCSuggestions,
    Card,
    FieldIncome,
  },

  data: () => ({}),
  props: {},
  async mounted() {
    this.___readyToAnimate = true;
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
    const spinner = document.getElementById("progress-bar");

    spinner.removeAttribute("hidden");
   // var response ='APPROVED'
   var response= await creditScoreCalService.creditScoreCalculation();
    spinner.setAttribute("hidden", "");
    console.log(response);
    var curreentStep = this.STEP_NAMES.continue;
    sendGAEvent(curreentStep, response);
    routeManager.goToFormByName(
      DECISION_FORM_MAP[routeManager.currentFormName][response]
    );
  },

  computed: {
    isCurrentStep() {
      
      return this.$store.state.formData.currentStepName;
    },
    isScreenChoice() {
      if (this.$store.state.source) {
        return this.$store.state.source;
      }
    },
  },
  methods: {},
};
</script>
<style scoped>
.p1 {
  padding-bottom: 20px;
  text-align: center;
  color: #6e3dea;
  font-weight: 500;
  font-size: 30px;
}
.p2 {
  text-align: center;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
}
.p1-insurance {
  padding-bottom: 20px;

  color: #6e3dea;
  font-weight: 500;
  font-size: 30px;
}
.p2-insurance {
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
}
.p3 {
  padding-left: 36%;
}
.choiceTitle1 {
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
  word-wrap: break-word;
  width: 300px;
}
.buttonClass {
  width: auto;
  height: 40px;
  color: white;
  display: block;
  margin-top: 0;
  text-align: center;
  border-radius: 0;
  margin-left: 30px;
  font-size: 12px;
  background: #6e3dea !important;
  padding-left: 8px;
  padding-right: 8px;
  text-transform: uppercase;
  cursor: pointer;
}
.buttonClass2 {
  width: auto;
  height: 30px;
  color: white;
  display: block;
  margin-top: 0;
  text-align: center;
  border-radius: 0;
  /* margin-left: 30px; */
  font-size: 12px;
  background: #6e3dea !important;
  padding-left: 20px;
  padding-right: 20px;
  text-transform: uppercase;
  cursor: pointer;
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;

  padding: 10px;
}
.grid-item {
  padding: 20px;
  font-size: 30px;
  /* text-align: center; */
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

.container .col p {
  padding: 0.25rem 0.75rem;
}

/* 2 columns (600px) */

@media only screen and (min-width: 600px) {
  .container .col {
    float: left;
    width: 50%;
  }
}

/* 3 columns (768px) */

@media only screen and (min-width: 768px) {
  .container .col {
    width: 33.333%;
  }
}

/* 4 columns (992px) */

@media only screen and (min-width: 992px) {
  .container .col {
    width: 25%;
  }
}
@media (max-width: 768px) {
  #wrapper {
    grid-template-columns: 4fr;
  }
}

@media (min-width: 1281px) {
  #wrapper {
    grid-template-columns: 2fr 2fr;
  }
}
@media (max-width: 1279px) {
  #wrapper {
    grid-template-columns: 2fr 2fr;
  }
}
#wrapper {
  display: grid;
}

/** */

.container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
}

.step2-col1 {
  grid-column: span 6;
}
.step2-col2 {
  grid-column: span 6;
}

@media screen and (max-width: 768px) {
  .step2-col1 {
    grid-column: span 12;
  }
  .step2-col2 {
    grid-column: span 12;
  }
}
/**Step Card Choice 1  */
.container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
}

.step3-col1 {
  grid-column: span 4;
}
.step3-col2 {
  grid-column: span 4;
}
.step3-col3 {
  grid-column: span 4;
}

ul.dashed {
  list-style-type: none;
  padding-top: 10px;
}
ul.dashed > li {
  text-indent: -5px;
}
ul.dashed > li:before {
  content: "- ";
  text-indent: -5px;
}
@media screen and (max-width: 950px) {
  .step3-col1 {
    grid-column: span 12;
  }
  .step3-col2 {
    grid-column: span 12;
  }
  .step3-col3 {
    grid-column: span 12;
  }
}
@media (max-width: 768px) {
  [class="p3"] {
    padding-left: 20%;
  }
}

/* Progess Bar with steps */
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  margin-top: 30px;
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  margin-top: 30px;
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  margin-top: 30px;
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}
.step-counter.active {
  background-color: #6e3dea;
}

.stepper-item.completed .step-counter {
  background-color: #6e3dea;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  /* border-bottom: 2px solid #6e3dea; */
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
.pointer {
  cursor: pointer;
}
li {
  word-wrap: break-word;
  width: 300px;
}
p.text-decoration {
  font-weight: bold;
}
p.text-decoration:hover {
  text-decoration: underline;
  cursor: pointer;
}

input.largerCheckbox {
  color: #6e3dea;
  width: 20px;
  height: 20px;
  background-color: brown;
}
.margin-top {
  margin-top: 30%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (max-width: 950px) {
  .margin-top {
    margin-top: 0;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}

#container {
  position: relative;
}

#progress-bar {
  position: absolute;
  top: 40%;
  left: 47%;
}
#spinner {
  position: absolute;
  top: 40%;
  left: 47%;
}
.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #6e3dea;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>